import { InterventionEvent } from "../scripts/interventions.entities";
import { InterventionsLookup } from "../scripts/interventions.lookup";

export class InterventionsSummarySeries {
    name: string;
    type: string;
    typeId: number;
    sortValue: number;
    interventions: Map<number, InterventionEvent[]>;

    constructor(name: string, type: string, typeId: number) {
        this.interventions = new Map<number, InterventionEvent[]>();
        this.name = name;
        this.type = type;
        this.typeId = typeId;
        this.sortValue = (type == "intervention") ? InterventionsLookup.GetInterventionOrdering(typeId) : 0;
    }

    addInterventionEvent(event: InterventionEvent): void {

        let interventionArray: InterventionEvent[];
        if (this.interventions.has(event.InterventionStatusId)) { interventionArray = this.interventions.get(event.InterventionStatusId); }
        else { interventionArray = []; }

        interventionArray.push(event);
        this.interventions.set(event.InterventionStatusId, interventionArray);
    }
}